<template>
  <div>
    <el-form :model="formData" label-width="110px">
      <el-form-item label="开发部：">
        <el-select v-model="formData.kfb" style="width: 20%">
          <el-option
              v-for="item in kfb"
              :key="item.BLOCK1_ID"
              :label="item.BLOCK1"
              :value="item.BLOCK1_ID"/>
        </el-select>
      </el-form-item>
      <el-form-item label="指标算法年度：">
        <el-date-picker
            v-model="formData.year_mon"
            type="year"
            value-format="YYYY"
            placeholder="请选择"
            style="width: 20%"
            :disabled="isTemplateInfo"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="考核指标分类：">
        <el-select v-model="formData.indexName" @change="onSelectType" style="width: 20%">
          <el-option
              v-for="item in indexTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.label"/>
        </el-select>
      </el-form-item>
      <el-form-item label="考核指标子类：">
        <el-select v-model="formData.sonType" @change="onSelectSonType"  style="width: 20%">
          <el-option
              v-for="item in indexSonTypeList[formData.indexName]"
              :key="item.value"
              :label="item.label"
              :value="item.label"/>
        </el-select>
      </el-form-item>
      <el-form-item label="考核子类总分：">
        <el-input-number v-model="formData.totalScore" :min="0" :max="100" style="width: 20%" :disabled="isTemplateInfo"/>
      </el-form-item>
      <el-form-item label="指标考核配置：" style="height: 400px;margin-bottom: 50px">
        <el-button type="text" @click="addIndexConfig" v-if="!isTemplateInfo">添加</el-button>
        <el-table
            v-if="formData.sonType=='动态监测资料质量'"
            :data="dataConfig"
            style="width: 90%"
            stripe
            max-height="350"
            border="10px">
          <el-table-column label="评价项目" prop="name" key="name" header-align="center">
            <template #default="{row,column,$index}">
              <el-input size="mini" v-model="dataConfig[$index].name" clearable placeholder="请填写名称" v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].name}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="合格率满分" prop="passPoints" key="passPoints" header-align="center">
            <template #default="{row, column, $index }">
              <el-input size="mini" v-model="dataConfig[$index].passPoints" clearable placeholder="请输入分数" v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].passPoints}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="优良率满分" prop="excellentPoints" key="excellentPoints" header-align="center">
            <template #default="{row,column,$index}">
              <el-input size="mini" v-model="dataConfig[$index].excellentPoints" clearable placeholder="请输入分数" v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].excellentPoints}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="评分" header-align="center" min-width="50px" align="center">
            <template #default="scope">
              <el-button type="primary" size="small" @click="setIndexConfig(scope.$index)">设置</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="!isTemplateInfo" align="center" min-width="50px">
            <template #default="scope">
              <el-button type="danger" size="small" @click="deleteIndexConfig(scope.$index)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table
            v-else-if="formData.sonType=='安全生产'"
            :data="dataConfig"
            style="width: 90%"
            stripe
            max-height="350"
            border="10px">
          <el-table-column label="事故级别" prop="label" key="label" header-align="center">
            <template #default="{row,column,$index}">
              <el-input size="mini" v-model="dataConfig[$index].label" clearable placeholder="请填写事故名称" v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].label}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="评分标准" prop="score" key="score" header-align="center">
            <template #default="{row, column, $index }">
              <el-input size="mini" v-model="dataConfig[$index].score" clearable placeholder="请输入评分标准" v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].score}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="!isTemplateInfo" align="center" min-width="50px">
            <template #default="scope">
              <el-button type="danger" size="small" @click="deleteIndexConfig(scope.$index)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table
            v-else-if="formData.sonType=='下年度方案编制'"
            :data="dataConfig"
            style="width: 90%"
            stripe
            max-height="350"
            border="10px">
          <el-table-column label="特殊项扣分" prop="label" key="label" header-align="center">
            <template #default="{row,column,$index}">
              <el-input size="mini" v-model="dataConfig[$index].label" clearable placeholder="请填写" v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].label}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="扣分标准" prop="score" key="score" header-align="center" >
            <template #default="{row, column, $index }">
              <el-input size="mini" v-model="dataConfig[$index].score" clearable placeholder="请输入评分标准" v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].score}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="扣分单位" prop="score" key="score" header-align="center" >
            <template #default="{row, column, $index }">
              <el-input size="mini" v-model="dataConfig[$index].company" clearable placeholder="分" v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].company}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="!isTemplateInfo" align="center" min-width="50px">
            <template #default="scope">
              <el-button type="danger" size="small" @click="deleteIndexConfig(scope.$index)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table
            v-else
            :data="dataConfig"
            style="width: 90%"
            stripe
            max-height="350"
            border="10px">
          <el-table-column label="指标名称" prop="name" key="name" header-align="center">
            <template #default="{row,column,$index}">
              <el-input size="mini" v-model="dataConfig[$index].name" clearable placeholder="请填写名称"  v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].name}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="计划数据源" prop="jh_dataID" key="jh_dataID" header-align="center">
            <template #default="scope">
              <el-select v-model="dataConfig[scope.$index].jh_dataID"
                         :disabled="isTemplateInfo"
                         @change="onSelectDataSrc($event,scope.$index,'jh',true)" filterable placeholder="请选择数据源"
                         size="small">
                <el-option
                    v-for="item in jh_dataSrcList"
                    :key="item.DATSRC_ID"
                    :label="item.DATSRC_NAME"
                    :value="item.DATSRC_ID">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="计划数据字段" prop="jh_field" key="jh_field" header-align="center">
            <template #default="scope">
              <el-select v-model="dataConfig[scope.$index].jh_field" :disabled="isTemplateInfo" filterable placeholder="请选择字段" size="small">
                <el-option
                    v-for="item in jh_fieldSelects[scope.$index]"
                    :key="item.COLUMN_NAME"
                    :label="item.COMMENTS"
                    :value="item.COLUMN_NAME">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="实际数据源" prop="sj_dataID" key="sj_dataID" header-align="center">
            <template #default="scope">
              <tree-select :value="dataConfig[scope.$index].sj_dataID" :props="treeSelectProps" :options="sj_dataSrcTree" @getValue="getValue($event,scope.$index)"></tree-select>
            </template>
          </el-table-column>
          <el-table-column label="实际数据字段" prop="sj_field" key="sj_field" header-align="center">
            <template #default="scope">
              <el-select v-model="dataConfig[scope.$index].sj_field" :disabled="isTemplateInfo" filterable placeholder="请选择字段" size="small">
                <el-option
                    v-for="item in sj_fieldSelects[scope.$index]"
                    :key="item.COLUMN_NAME"
                    :label="item.COMMENTS"
                    :value="item.COLUMN_NAME">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="指标满分" prop="indexPoints" key="indexPoints" header-align="center">
            <template #default="{row, column, $index }">
              <el-input size="mini" v-model="dataConfig[$index].indexPoints" clearable placeholder="请输入分数" v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].indexPoints}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="符合率算法" prop="arithmetic" key="arithmetic" header-align="center">
            <template #default="{row,column,$index}">
              <el-input size="mini" v-model="dataConfig[$index].arithmetic" clearable placeholder="请填写算法" v-if="!isTemplateInfo"></el-input>
              <span v-else>{{dataConfig[$index].arithmetic}}</span>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="评分" align="center" min-width="50px">
            <template #default="scope">
              <el-button type="primary" size="small" @click="setIndexConfig(scope.$index)">设置</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="!isTemplateInfo" align="center" min-width="50px">
            <template #default="scope">
              <el-button type="danger" size="small" @click="deleteIndexConfig(scope.$index)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item v-if="!isTemplateInfo">
        <el-row>
          <el-col :span="3" :offset="15">
            <el-dropdown v-if="dataConfig.length!=0">
              <el-button type="primary">复制配置</el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="copyConfig('all')">所有</el-dropdown-item>
                  <el-dropdown-item @click="copyConfig('part')">未配置</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="large" @click="importAlgorithm('import')">导入上年算法</el-button>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" size="large" @click="onSubmit">提交</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <!--考核指标评分——弹出框-->
    <div v-dialogDrag v-if="formData.sonType!='动态监测资料质量'">
      <el-dialog
          v-model="isConfigSet"
          title="考核指标评分"
          width="40%">
        <el-table :data="configScoretableData" border stripe>
          <el-table-column
              v-for="item in configScoreHeader"
              :prop="item.id"
              :label="item.name"
              :key="item.id"
              :width="item.width">
            <template #default="scope">
              <el-input size="mini" v-model="configScoretableData[scope.$index][item.id]" :id="item.id+scope.$index"
                        :disabled="item.id=='scoringItems' || (item.id=='algorithm' && scope.$index<2)" clearable
                        @focus="focusConfigScoretableData(scope.$index,item.id)"
                        @blur="blurConfigScoretableData"
              v-if="!isTemplateInfo"></el-input>
              <span v-else>{{ configScoretableData[scope.$index][item.id] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-divider content-position="center" style="height: 3px"></el-divider>
        <el-row v-for="symbol in configSymbol" :key="symbol">
          <el-col :span="3" :offset="2" v-for="item in symbol" :key="item.value">
            <button class="configScoreButton" @click="onConfigButton(item.value)">{{ item.value }}</button>
          </el-col>
        </el-row>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="isConfigSet = false">取消</el-button>
                <el-button type="primary" @click="configSetOk">确认</el-button>
            </span>
        </template>
      </el-dialog>
    </div>
    <!--考核指标评分(动态监测资料质量)——弹出框-->
    <div v-dialogDrag v-if="formData.sonType=='动态监测资料质量'">
      <el-dialog
          v-model="isConfigSet"
          title="考核指标评分"
          width="40%">
        <span>合格率</span>
        <el-table :data="configScoretableData['pass']" border stripe>
          <el-table-column
              v-for="item in configScoreHeader"
              :prop="item.id"
              :label="item.name"
              :key="item.id"
              :width="item.width">
            <template #default="scope">
              <el-input size="mini" v-model="configScoretableData['pass'][scope.$index][item.id]"
                        :id="item.id+scope.$index"
                        :disabled="item.id=='scoringItems' || (item.id=='algorithm' && scope.$index<2)" clearable
                        @focus="focusConfigScoretableData(scope.$index,item.id)"
                        @blur="blurConfigScoretableData"
                        v-if="!isTemplateInfo"></el-input>
              <span v-else>{{ configScoretableData['pass'][scope.$index][item.id] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-divider content-position="center" style="height: 3px"></el-divider>
        <span>优良率</span>
        <el-table :data="configScoretableData['excellent']" border stripe>
          <el-table-column
              v-for="item in configScoreHeader"
              :prop="item.id"
              :label="item.name"
              :key="item.id"
              :width="item.width">
            <template #default="scope">
              <el-input size="mini" v-model="configScoretableData['excellent'][scope.$index][item.id]"
                        :id="item.id+scope.$index"
                        :disabled="item.id=='scoringItems' || (item.id=='algorithm' && scope.$index<1)" clearable
                        @focus="focusConfigScoretableData(scope.$index,item.id)"
                        @blur="blurConfigScoretableData"
                        v-if="!isTemplateInfo"></el-input>
              <span v-else>{{ configScoretableData['excellent'][scope.$index][item.id] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="isConfigSet = false">取消</el-button>
                <el-button type="primary" @click="configSetOk">确认</el-button>
            </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {ElMessage} from "element-plus";
import docFileUploader from "@/components/docFileUploader";
import treeSelect from "@/components/treeSelect";

export default {
  name: "IndexAlgorithmMangerView",
  components: {docFileUploader,treeSelect},
  props:{
    templateInfo: {
      default: null
    },
  },
  data() {
    return {
      formData: {
        kfb:"3172BF3EF8B84ACDBFEEF0E8E62DBF2B",//开发部 默认：东河油气开发部
        year_mon: "2022",
        indexName: "指标符合率",
        sonType: "月度指标",
        totalScore: null,
      },//考核算法相关数据
      kfb:[],//开发部 列表
      indexTypeList: [
        {
          value: "index",
          label: "指标符合率",
        },
        // {
        //   value: "dynamic",
        //   label: "动态监测指标",
        // },
        {
          value: "programme",
          label: "综合治理方案",
        }
      ],//考核指标分类 列表
      indexSonTypeList: {
        "指标符合率": [
          {
            value: "index_monSonIndex",
            label: "月度指标"
          }, {
            value: "index_yearSonIndex",
            label: "年度指标"
          }
        ],
        "动态监测指标": [
          {
            value: "dynamic_project",
            label: "关键项目符合率"
          }, {
            value: "dynamic_data",
            label: "动态监测资料质量"
          }, {
            value: "dynamic_security",
            label: "安全生产"
          }
        ],
        "综合治理方案": [
          {
            value: "programme_nextYear",
            label: "下年度方案编制"
          }
        ]
      },//考核指标子类 列表
      dataConfig: [],//指标配置数据集
      jh_dataSrcList: [],//计划数据源下拉框
      jh_fieldSelects: [],//计划字段下拉框 集合
      sj_dataSrcList: [],//实际数据源下拉框
      sj_dataSrcTree: [],//实际数据源下拉框(树形)
      sj_dataSrcCascader:{
        value:"DATSRC_ID",
        label:"DATSRC_NAME",
      },//修改级联选择器的默认节点名称——实际数据源
      sj_fieldSelects: [],//实际字段下拉框 集合
      isConfigSet: false,//指标配置——指标考核评分弹出框标识
      configScoreHeader: [
        {
          id: "scoringItems",
          name: "评分项",
          width: "100px"
        },
        {
          id: "judge",
          name: "判断条件",
          width: ""
        },
        {
          id: "algorithm",
          name: "得分算法",
          width: ""
        },
      ],//指标考核评分 表头内容
      configScoretableDataTemp: [
        {
          scoringItems: "满分",
          judge: "(符合率>=100)且(符合率<=110)",
          algorithm: "满分",
        },
        {
          scoringItems: "0分",
          judge: "(40-(100-符合率))<0",
          algorithm: "0",
        },
        {
          scoringItems: "加分",
          judge: "符合率>110",
          algorithm: "满分+(符合率-110)/5*0.01",
        },
        {
          scoringItems: "非满分",
          judge: "(符合率<100)且(40-(100-符合率)>0)",
          algorithm: "满分-(100-符合率)/40*20/((评分年月-起算年月)*指标个数)",
        },
      ],//指标考核评分 报表数据——模板数据
      configScoretableDataDynamicTemp:{
        "pass": [
          {
            scoringItems: "满分",
            judge: "合格率==100",
            algorithm: "满分",
          },
          {
            scoringItems: "0分",
            judge: "合格率＜100",
            algorithm: "0",
          },
        ],
        "excellent": [
          {
            scoringItems: "满分",
            judge: "95>=优良率>=85",
            algorithm: "满分",
          },
          {
            scoringItems: "加分",
            judge: "优良率＞95",
            algorithm: "(优良率-95)*0.1",
          },
          {
            scoringItems: "减分",
            judge: "优良率＜85",
            algorithm: "(85-优良率)*0.1",
          },
        ],
      },//指标考核评分(动态监测资料质量) 报表数据——模板数据
      configScoretableData: null,//指标考核评分 报表数据
      configSetIndex: 0,//记录当前选中设置  在指标配置数据集 中的位置
      configSymbol: [
        [
          {
            value: "且"
          },
          {
            value: "或"
          },
          {
            value: "绝对值()"
          },
          {
            value: "满分"
          },
        ],
        [
          {
            value: "评分年月"
          },
          {
            value: "起算年月"
          },
          {
            value: "符合率"
          },
          {
            value: "指标个数"
          },
        ]
      ],//指标考核评分 符号集
      configScoretableDataModify: {},//记录当前获取焦点的指标考核评分 报表数据 的位置和名称信息
      produceTableData: [
        {
          label: "发生一般C级及以上安全事故",
          score:"不得分",
        },
        {
          label: "发生工具串或仪器落井等生产事件",
          score: "-0.5"
        },
        {
          label: "遇阻、遇卡处理周期超过3天",
          score: "-0.2"
        },
        {
          label: "发生生产安全事故事件谎报、瞒报、不报",
          score: "-1"
        },
        {
          label: "作业期间主动发现较大或重大安全隐患，并采取有效控制措施及时消除安全隐患",
          score: "+0.2"
        },
      ],//安全生产指标配置报表数据
      nextYearTableData: [
        {
          label: "一次性通过审查",
          score:"不扣分",
          company:"分",
        },
        {
          label: "第二次审查通过",
          score: "-10",
          company:"分",
        },
        {
          label: "第二次审查未通过",
          score: "-20",
          company:"分",
        },
        {
          label: "未按时完成方案审查，提交方案报告",
          score: "-10",
          company:"分",
        },
        {
          label: "方案报告中存在数据质量问题",
          score: "-0.1",
          company:"处/分",
        },
      ],//安全生产指标配置报表数据
      isTemplateInfo:false,//模板调用标识
      treeSelectProps: {
        value: 'DATSRC_ID',             // ID字段名
        label: 'DATSRC_NAME',         // 显示名称
        children: 'children'    // 子级字段名
      },//树形下拉框传递参数的对应关系
    }
  },
  mounted() {
    //首次调用加载替换年份
    if (this.templateInfo!=null){
      this.isTemplateInfo=true;
      console.log(this.isTemplateInfo)
      this.formData.year_mon=this.templateInfo.YEAR_MON;
    }
    this.loadKfbList();
    this.loadDataSrcList();
  },
  methods: {
    //初始化加载开发部列表
    loadKfbList(){
      axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/index/loadKfbList").then(res => {
        this.kfb = res.data;
      }).catch(err => {
        console.log(err);
      });
    },
    //初始化加载数据源列表
    loadDataSrcList() {
      axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/index/loadDataSrcList").then(res => {
        console.log("数据源下拉列表：", res.data);
        this.sj_dataSrcList = res.data.sj_dataSrc;
        this.sj_dataSrcTree = res.data.sj_dataSrcTree;
        this.jh_dataSrcList = res.data.jh_dataSrc;
        this.importAlgorithm("initial");
      }).catch(err => {
        console.log(err);
      });
    },
    //考核指标分类下拉框 改变选择时 触发
    onSelectType() {
      //修改考核指标子类的数据；
      this.formData.sonType = this.indexSonTypeList[this.formData.indexName][0].label;
      if (this.formData.sonType=="下年度方案编制"){
        this.formData.totalScore = 50;
        this.dataConfig=this.nextYearTableData;
      }
    },
    //考核指标子类下拉框 改变选择时 触发
    onSelectSonType(value) {
      this.formData.totalScore = null;
      this.dataConfig = [];
      if (value=="动态监测资料质量"){
        this.formData.totalScore = 4;
      }else if (value=="安全生产"){
        this.formData.totalScore = 3;
        this.dataConfig=this.produceTableData;
      }else if (value=="下年度方案编制"){
        this.formData.totalScore = 50;
        this.dataConfig=this.nextYearTableData;
      }
    },
    //添加按钮
    addIndexConfig() {
      let verification="初始化";//验证信息
      if (this.messageVerification(verification)==false)
        return
      if (this.formData.sonType == "动态监测资料质量") {
        let data = {};
        data.name = null;//评价项目
        data.passPoints = null;//合格率满分
        data.excellentPoints = null;//优良率满分
        data.configScoretableData = JSON.parse(JSON.stringify(this.configScoretableDataDynamicTemp));//获取默认评分信息
        this.dataConfig.push(data);
      }
      else if (this.formData.sonType == "安全生产") {
        let data = {};
        data.label = null;//事故级别
        data.score = null;//评分标准
        this.dataConfig.push(data);
      }
      else if (this.formData.sonType == "下年度方案编制") {
        let data = {};
        data.label = null;//特殊项扣分
        data.score = null;//扣分标准
        data.company = null;//评分标准
        this.dataConfig.push(data);
      }
      else {
        let data = {};//创建考核配置对象
        data.name = null;//配置名称
        data.jh_dataID = null;//计划数据源id（唯一）
        data.jh_dataUrl = null;//计划数据源地址（不唯一）
        data.jh_field = null;//计划字段
        data.sj_dataID = null;//实际数据源id（唯一）
        data.sj_dataUrl = null;//实际数据源地址（不唯一）
        data.sj_field = null;//实际字段
        data.indexPoints = null;//指标满分
        data.arithmetic = "(实际/计划)*100";//符合率算法
        data.configScoretableData = JSON.parse(JSON.stringify(this.configScoretableDataTemp));//获取默认评分信息
        this.dataConfig.push(data);
      }
    },
    //指标配置——计划数据源/实际数据源 下拉框  改变选择时 触发 val:选中的值，index:选中的指标配置记录的下标，type:选择的数据源类型,state:触发方式：true—选择，false—调用
    onSelectDataSrc(val, index, type,state) {
      let selectLiet = this.jh_dataSrcList;//根据 type 的值获取对应的数据源下拉列表
      if (type == "sj") {
        selectLiet = this.sj_dataSrcList;
      }
      let selcetMun = selectLiet.findIndex((item) => {
        return item.DATSRC_ID == val;
      });//获取选择数据源 记录的 下标
      //根据 type 获取对应的数据源字段下拉框列表,并清空字段选择的数据
      if (type == "jh") {
        this.jh_fieldSelects[index] = this.jh_dataSrcList[selcetMun].HEAD[0].header;
        this.dataConfig[index].jh_dataUrl = this.jh_dataSrcList[selcetMun].DATAURL;
        //选择触发则情清空字段名
        if (state){
          this.dataConfig[index].jh_field = "";
        }
      }
      if (type == "sj") {
        this.sj_fieldSelects[index] = this.sj_dataSrcList[selcetMun].HEAD;
        this.dataConfig[index].sj_dataUrl = this.sj_dataSrcList[selcetMun].DATAURL;
        //选择触发则情清空字段名
        if (state){
          this.dataConfig[index].sj_field = "";
        }
      }
    },
    //指标配置——移除按钮
    deleteIndexConfig(index) {
      this.dataConfig.splice(index, 1);
    },
    //指标配置——设置按钮
    setIndexConfig(index) {
      this.configSetIndex = index;//记录选中指标配置记录的下标
      this.configScoretableData = null;
      //获取评分信息
      this.configScoretableData = JSON.parse(JSON.stringify(this.dataConfig[index].configScoretableData));
      this.isConfigSet = true;
    },
    //指标考核评分框——确定按钮
    configSetOk() {
      //保存评分信息
      this.dataConfig[this.configSetIndex].configScoretableData = JSON.parse(JSON.stringify(this.configScoretableData));
      console.log(this.dataConfig);
      this.isConfigSet = false;
    },
    //提交按钮
    onSubmit() {
      console.log(this.formData);
      console.log(this.dataConfig);
      let verification="初始化，开发部，数据完整";//验证信息
      if (this.messageVerification(verification)==false){
        return
      }
      let token = localStorage.getItem("lyqtJwt");
      // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
      let url=process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assess/add" +
          "?assessClassify="+this.formData.indexName+"&assessSubclass="+this.formData.sonType+"&assessSubclassScore="+parseInt(this.formData.totalScore)+"&yearMon="+this.formData.year_mon+"&assessKfb="+this.formData.kfb;

      let params=this.handleParamsData(this.formData.sonType);
      axios.post(url,params,{ headers:{"authorization": "Bearer " + token},}).then(res => {
        console.log(res)
        ElMessage.success("已提交");
      }).catch(err => {
        console.log(err);
      });
    },
    //查询算法, type:import——导入上年算法,initial——初始化加载本年算法
    importAlgorithm(type){
      let verification="初始化，年度";//验证信息
      if (this.messageVerification(verification)==false)
        return
      let formData=JSON.parse(JSON.stringify(this.formData));
      //导入上年算法，则年份减一
      if (type=="import")
       formData.year_mon = (formData.year_mon-1).toString();
      let url=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/index/importAlgorithm";
      axios.post(url,{formData:formData}).then(res=>{
        console.log(res.data);
        if (res.data.success==true){
          this.formData.totalScore=res.data.score;
          this.handleDataConfig(formData.sonType,res.data.config);
        }else {
          this.dataConfig = [];
          ElMessage(res.data.msg);
        }
      }).catch(err=>{
        console.log(err);
      })
    },
    //数据验证函数
    messageVerification(verification){
      if (verification.indexOf("初始化")!=-1 && this.jh_dataSrcList.length==0){
        ElMessage("数据加载中，请稍后");
        return false
      }
      if (verification.indexOf("开发部")!=-1 && this.formData.kfb==""){
        ElMessage("请选择开发部");
        return false
      }
      if (verification.indexOf("年度")!=-1 && this.formData.year_mon==null){
        ElMessage("请选择年度");
        return false
      }
      if (verification.indexOf("数据完整")!=-1 && (JSON.stringify(this.formData).indexOf("null")!=-1 || this.dataConfig.length==0 || JSON.stringify(this.dataConfig).indexOf("null")!=-1)){
        ElMessage("请完善数据")
        return false
      }

      return true;
    },
    //复制配置按钮
    copyConfig(type){
      let verification="初始化，数据完整";//验证信息
      if (this.messageVerification(verification)==false)
        return
      let url=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/index/copyConfig";
      axios.post(url,{
        formData:this.formData,
        type:type
      }).then(res=>{
        console.log(res.data);
        if (res.data.success)
          ElMessage.success("已复制");
        else
          ElMessage(res.data.msg);
      }).catch(err=>{
        console.log(err);
      })
    },
    //根据类型处理提交的数据（数据格式：前端改成后台）
    handleParamsData(sonType) {
      let params = [];
      if (sonType == "动态监测资料质量") {
        for (let i = 0; i < this.dataConfig.length; i++) {
          let oneData = {
            "indexName": this.dataConfig[i].name,
            "passPoints": parseFloat(this.dataConfig[i].passPoints),
            "excellentPoints": parseFloat(this.dataConfig[i].excellentPoints),
            "gradingConfig": JSON.parse(JSON.stringify(this.dataConfig[i].configScoretableData))
          };
          params.push(oneData);
        }
      }
      else if (sonType == "安全生产" || sonType=="下年度方案编制") {
        params = this.dataConfig;
      }
      else {
        for (let i = 0; i < this.dataConfig.length; i++) {
          let oneData = {
            "indexName": this.dataConfig[i].name,
            "planDataID": this.dataConfig[i].jh_dataID,
            "planData": this.dataConfig[i].jh_dataUrl,
            "planField": this.dataConfig[i].jh_field,
            "practicalDataID": this.dataConfig[i].sj_dataID,
            "practicalData": this.dataConfig[i].sj_dataUrl,
            "practicalField": this.dataConfig[i].sj_field,
            "indexPoints": parseFloat(this.dataConfig[i].indexPoints),
            "arithmetic": this.dataConfig[i].arithmetic,
            "gradingConfig": JSON.parse(JSON.stringify(this.dataConfig[i].configScoretableData))
          };
          params.push(oneData);
        }
      }
      console.log("params:", params);
      return params;
    },
    //根据类型处理查询算法的数据（数据格式：后端改成前端）
    handleDataConfig(sonType,params){
      this.dataConfig = [];
      if (sonType == "动态监测资料质量") {
        for (let i = 0; i < params.length; i++) {
          let data = {};
          data.name = params[i].indexName;//评价项目
          data.passPoints = params[i].passPoints;//合格率满分
          data.excellentPoints = params[i].excellentPoints;//优良率满分
          data.configScoretableData = JSON.parse(JSON.stringify(params[i].gradingConfig));//获取默认评分信息
          this.dataConfig.push(data);
        }
      }
      else if (sonType == "安全生产" || sonType=="下年度方案编制") {
        this.dataConfig = params;
      }
      else {
        for (let i = 0; i < params.length; i++) {
          let data = {};//创建考核配置对象
          data.name = params[i].indexName;//配置名称
          data.jh_dataID = params[i].planDataID;//计划数据源id（唯一）
          data.jh_dataUrl = params[i].planData;//计划数据源地址（不唯一）
          data.jh_field = params[i].planField;//计划字段
          data.sj_dataID = params[i].practicalDataID;//实际数据源id（唯一）
          data.sj_dataUrl = params[i].practicalData;//实际数据源地址（不唯一）
          data.sj_field = params[i].practicalField;//实际字段
          data.indexPoints = params[i].indexPoints;//指标满分
          data.arithmetic = params[i].arithmetic;//符合率算法
          data.configScoretableData = JSON.parse(JSON.stringify(params[i].gradingConfig));//获取默认评分信息
          this.dataConfig.push(data);
          this.onSelectDataSrc(this.dataConfig[i].jh_dataID,i,"jh",false);
          this.onSelectDataSrc(this.dataConfig[i].sj_dataID,i,"sj",false);
        }
      }
      console.log("dataConfig:", this.dataConfig);
    },
    //指标考核评分框——配置按钮(且，或。。。)
    onConfigButton(val) {
      //未获得焦点时，退出
      if (!("id" in this.configScoretableDataModify))
        return
      //获取文本信息并修改
      let text = this.configScoretableData[this.configScoretableDataModify.index][this.configScoretableDataModify.id];
      if (val == "绝对值()")
        text = "绝对值(" + text + ")";
      else
        text += val;
      //替换文本信息
      this.configScoretableData[this.configScoretableDataModify.index][this.configScoretableDataModify.id] = text;
      //使文本框重新获取焦点
      document.getElementById(this.configScoretableDataModify.id + this.configScoretableDataModify.index).focus();
    },
    //指标考核评分框——报表数据获取焦点时触发
    focusConfigScoretableData(index, id) {
      // console.log(index,id);
      this.configScoretableDataModify.index = index;//记录获取焦点的列
      this.configScoretableDataModify.id = id;//记录获取焦点的id
    },
    //指标考核评分框——报表数据失去焦点时触发
    blurConfigScoretableData() {
      // this.configScoretableDataModify={}
    },

    //实际数据源下拉框切换
    getValue(value,index){
      this.dataConfig[index].sj_dataID = value;
      this.onSelectDataSrc(value,index,'sj',true);
    },
  },
  watch: {
    //监听指标考核评分框的状态
    isConfigSet: function () {
      if (this.isConfigSet == true)
        this.configScoretableDataModify = {};//清空焦点信息
    },
    //监听对应值的变化，修改时加载配置信息
    "formData.kfb":{
      handler() {
        console.log("监听开发部：",this.formData.kfb);
        this.importAlgorithm("initial");
      },
    },
    "formData.year_mon":{
      handler() {
        console.log("监听年份：",this.formData.year_mon);
        this.importAlgorithm("initial");
      },
    },
    "formData.sonType":{
      handler() {
        console.log("监听子类：",this.formData.sonType);
        this.importAlgorithm("initial");
      },
    },
    //监听调用数据变化（用于修改除首次调用）
    templateInfo:{
      handler() {
        console.log(this.templateInfo);
        this.isTemplateInfo=true;
        this.formData.year_mon=this.templateInfo.YEAR_MON;
      },
      deep:true
    }
  }
}
</script>

<style scoped>
.module-pagetree {
  position: absolute;
  overflow: auto;
  width: 100%;
  height: auto;
  max-height: 250px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 1000;
}

.configScoreButton {
  width: 100%;
  height: 30px;
  margin-bottom: 20px;
}


.fromItem{
  margin-top: 50px;
  width: 70%;
}
/*考核——新增弹出框样式*/
.fromItem>fieldset>.el-row{
  padding-bottom: 10px;
  margin-top: 20px;
}

</style>